/**
 * The support team's side of a portal order: the conversation with its supplier.
 *
 * Separate from portal_users on purpose — that one is about who may sign in,
 * this one is about what is being said on an order once they have.
 */
define('entities/suppliers/portal_orders',[
  'app',
  'jquery',
  'settings'
], function (
  App,
  $,
  Settings
) {
  'use strict';

  var API = {
    /** Orders where a supplier wrote and nobody here has opened it, every supplier at once. */
    getWaiting: function () {
      return $.ajax({
        type: 'GET',
        url: Settings.url('compuzz2', 'v2/portalOrders/waiting')
      });
    },

    /** From a notification, which carries the purchase order id and nothing else. */
    getByPoi: function (poi) {
      return $.ajax({
        type: 'GET',
        url: Settings.url('compuzz2', 'v2/portalOrders/byPoi', {poi: poi})
      });
    },

    /** Reading it is what tells the supplier their message was seen. */
    getMessages: function (orderSecId) {
      return $.ajax({
        type: 'GET',
        url: Settings.url('compuzz2', 'v2/portalOrders/' + orderSecId + '/messages')
      });
    },

    reply: function (orderSecId, body) {
      return $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'v2/portalOrders/' + orderSecId + '/messages'),
        contentType: 'application/json',
        data: JSON.stringify({body: body})
      });
    }
  };

  App.reqres.setHandler('portal-orders:waiting', function () {
    return API.getWaiting();
  });

  App.reqres.setHandler('portal-orders:by-poi', function (poi) {
    return API.getByPoi(poi);
  });

  App.reqres.setHandler('portal-orders:messages', function (orderSecId) {
    return API.getMessages(orderSecId);
  });

  App.reqres.setHandler('portal-orders:reply', function (orderSecId, body) {
    return API.reply(orderSecId, body);
  });
});

